import { storyCardCoverAttrs } from "../../../lib/responsive-story-images.js";
import { pickListCardTaglineText } from "../../../lib/reader-tagline.js";
import LlCardLocaleText from "../ll-card-locale-text.marko";
import LlFavoriteHeart from "../ll-favorite-heart.marko";

<div
  class="card card--story ll-card-shell"
  data-card-slug=input.item.slug
  data-content-id=(input.item.contentId || input.item.slug)
  data-stats=(input.item.stats ? JSON.stringify(input.item.stats) : null)
  data-card-level=(input.item.level || '').toLowerCase()
  data-plot-primary-category=(input.item.plotPrimaryCategory || '')
  data-plot-category-score=(input.item.plotCategoryScore != null ? input.item.plotCategoryScore : '')
  data-plot-categories=(input.item.plotCategories ? JSON.stringify(input.item.plotCategories) : '[]')
>
  <a href=`${input.basePath}/${input.item.slug}` class="card__link" style="text-decoration:none">
    <div class="card__image-wrap">
      <for|cover| of=[storyCardCoverAttrs(input.item)]>
        <img
          src=cover.src
          srcset=(cover.srcSet || null)
          sizes=(cover.sizes || null)
          alt=(input.item.targetTitle || input.item.title || "")
          class="card__image"
          width=cover.width
          height=cover.height
          loading="lazy"
          decoding="async"
          data-ll-responsive-cover=(cover.responsive ? "1" : null)
          onError="this.style.display='none';this.parentElement.innerHTML='<div class=card__image-placeholder>📖</div>'"
        >
      </for>
    </div>
    <div class="card__body">
      <div class="card__meta card__meta--story">
        <div class="ll-card-level-stripe-host" data-level-stripe tabindex="-1" aria-hidden="true"></div>
        <if=(input.item.storyCardBadge)>
          <span class="badge badge--story-meta">${input.item.storyCardBadge}</span>
        </if>
      </div>
      <if=(input.item.learnerTitle || input.item.translatedTitle)>
        <p class="title-aid">
          <LlCardLocaleText
            text=(input.item.learnerTitle || input.item.translatedTitle)
            item=input.item
            slot="titleAid"
            sectionKey=(input.sectionKey || "stories")
            uiLang=$global.uiLang
            targetCode=$global.targetCode
          />
        </p>
        <h2 class="card__title">
          <span data-ll-card-title-slot>
            <LlCardLocaleText
              text=(input.item.targetTitle || input.item.title)
              item=input.item
              slot="title"
              sectionKey=(input.sectionKey || "stories")
              uiLang=$global.uiLang
              targetCode=$global.targetCode
            />
          </span>
        </h2>
      </if>
      <else>
        <h2 class="card__title">
          <span data-ll-card-title-slot>
            <LlCardLocaleText
              text=(input.item.targetTitle || input.item.title)
              item=input.item
              slot="title"
              sectionKey=(input.sectionKey || "stories")
              uiLang=$global.uiLang
              targetCode=$global.targetCode
            />
          </span>
        </h2>
      </else>
      <p class="card__teaser">
        <span data-ll-card-teaser-slot>
          <LlCardLocaleText
            text=(pickListCardTaglineText(input.item))
            item=input.item
            slot="teaser"
            sectionKey=(input.sectionKey || "stories")
            uiLang=$global.uiLang
            targetCode=$global.targetCode
          />
        </span>
      </p>
      <div class="ll-card-stripe ll-card-stripe--bottom" data-stripe-bottom aria-hidden="true"></div>
    </div>
  </a>
  <LlFavoriteHeart contentId=(input.item.contentId || input.item.slug)/>
</div>
